



const GreetingUser = () => {
    const holidays = [
        { name: "New Year's Day", month: 1, day: 1 },
        { name: "Martin Luther King Jr. Day", month: 1, day: 15 }, // Fixed example, adjust dynamically for third Monday
        { name: "Presidents' Day", month: 2, day: 20 }, // Fixed example, adjust dynamically for third Monday
        { name: "Memorial Day", month: 5, day: 29 }, // Fixed example, adjust dynamically for last Monday
        { name: "Independence Day", month: 7, day: 4 },
        { name: "Labor Day", month: 9, day: 4 }, // Adjust dynamically for first Monday
        { name: "Veterans Day", month: 11, day: 11 },
        { name: "Thanksgiving Day", month: 11, day: 28 }, // Adjust dynamically for fourth Thursday
        { name: "holidays", month: 11, day: 29 }, // Adjust dynamically for fourth Thursday
        { name: "Christmas Day", month: 12, day: 25 },
    ];

    // Get today's date
    const today = new Date();
    const currentMonth = today.getMonth() + 1; // Months are zero-indexed
    const currentDay = today.getDate();

    // Check if today matches a holiday
    const todayHoliday = holidays.find(
        (holiday) => holiday.month === currentMonth && holiday.day === currentDay
    );

    // Create a greeting
    let greeting;
    if (todayHoliday) {
        greeting = `Happy ${todayHoliday.name}!`;
    } else {
        const currentHour = today.getHours();
        if (currentHour >= 5 && currentHour < 12) {
            greeting = "Good Morning!";
        } else if (currentHour >= 12 && currentHour < 18) {
            greeting = "Good Afternoon!";
        } else if (currentHour >= 18 && currentHour < 22) {
            greeting = "Good Evening!";
        } else {
            greeting = "Good Night!";
        }
    }

    return greeting

}




export default GreetingUser;